import { render, staticRenderFns } from "./MensagemAvisoLoginDialog.vue?vue&type=template&id=7c51dc5a"
import script from "./MensagemAvisoLoginDialog.vue?vue&type=script&lang=js"
export * from "./MensagemAvisoLoginDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports